// ImageFormat Enum für festgelegte Bildformate
export enum ImageFormat {
    SixteenToNine = '16_9',
    FourToThree = '4_3',
    OneToOne = '1_1',
    ThreeToFour = '3_4',
    NineToSixteen = '9_16',
    Free = 'Frei zuschneiden'
}

// Koordinatensystem und zugehörige Breakpoints
export enum CoordinatesSystem {
    MaxAspectRatio = 'max-aspect-ratio',
    DeviceSpecific = 'device-specific',
    ScreenWidth = 'screen-width',
    NoCoordinates = 'no-coordinates'
}

// Breakpoints für jedes Koordinatensystem
export enum MaxAspectRatioBreakpoints {
    Landscape = 'landscape',      // e.g., 16:9
    Portrait = 'portrait',        // e.g., 9:16
    Square = 'square',            // e.g., 1:1
    FourToThree = '4:3',          // e.g., 4:3
    ThreeToFour = '3:4'           // e.g., 3:4
}

export enum DeviceSpecificBreakpoints {
    Handset = 'handset',
    Tablet = 'tablet',
    Web = 'web'
}

export enum ScreenWidthBreakpoints {
    XSmall = 'xsmall',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    XLarge = 'xlarge'
}

export enum NoBreakpoints {
    Unset = 'unset'
}